import { call, put, takeLatest } from 'redux-saga/effects';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { GET_USER_INFO_FROM_MILES, GET_USER_INFO_FROM_MILES_ERROR, GET_USER_INFO_FROM_MILES_SUCCESS, GET_USER_MILES_SUCCESS, GET_USER_MILES_ERROR, CREATE_USER_MILES_ERROR, CREATE_USER_MILES_SUCCESS, GET_MONTHLY_RANKING_ERROR, GET_PAST_MONTHLY_RANKING_ERROR, GET_MONTHLY_RANKING_SUCCESS, GET_PAST_MONTHLY_RANKING_SUCCESS, BALANCE_INQUIRY_API, BALANCE_INQUIRY_API_ERROR, BALANCE_INQUIRY_API_SUCCESS, UNLINK_CARD, UNLINK_CARD_ERROR, UNLINK_CARD_SUCCESS, LINK_KFC_CARD, LINK_KFC_CARD_ERROR, LINK_KFC_CARD_SUCCESS, GET_USER_MILES_CURRENT_HISTORY_SUCCESS, GET_USER_MILES_CURRENT_HISTORY_ERROR, GET_USER_MILES_PAST_HISTORY_SUCCESS, GET_USER_MILES_PAST_HISTORY_ERROR, NAVIGATE_TO_EXTERNAL_WEBSITE, GET_LAST_MONTH_RANKING_View_ERROR, GET_LAST_MONTH_RANKING_View_SUCCESS, GET_RANKING_View_ERROR, GET_RANKING_View_SUCCESS, GET_OVERALL_RANKING_SUCCESS, GET_OVERALL_RANKING_ERROR, STORE_RETURNED_ACCOUNT_ID, PONTA_MEMBER_ID_SUCCESS, PONTA_MEMBER_ID_ERROR, GET_USER_OVERALL_RANKING_SUCCESS, GET_USER_OVERALL_RANKING_ERROR, } from '../constants';
import { setErrorCode } from '../redux/Actions/ErrorAction';
import { setErrorMsg, setIsLoading, linkCardStatusMsg, linkCard } from '../redux/Actions/LoyaltyMileageAction';
import { format, subYears, subMonths } from 'date-fns';
const apiCallHandler = invokeApi;
const errorMessage = 'something went wrong';
export function* getUserInfoFromMilesCall() {
    try {
        const { response, status } = yield call(apiCallHandler, networkConfig.getUserInfoFromMiles, null, {}, {});
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            if (!response?.MilesUUID) {
                yield createUserMilesCall();
            }
            yield put({
                type: GET_USER_INFO_FROM_MILES_SUCCESS,
                payload: {
                    userMiles: response,
                },
            });
        }
        else {
            yield put({
                type: GET_USER_INFO_FROM_MILES_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_USER_INFO_FROM_MILES_ERROR,
        });
    }
}
export function* createUserMilesCall() {
    try {
        const { response, status } = yield call(apiCallHandler, networkConfig.createUserMiles, null, {}, {});
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: CREATE_USER_MILES_SUCCESS,
                payload: {
                    userMiles: response,
                },
            });
        }
        else {
            yield put({
                type: CREATE_USER_MILES_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: CREATE_USER_MILES_ERROR,
        });
    }
}
export function* getUserMilesCall(request) {
    try {
        const uuid = request?.payload?.userMiles?.MilesUUID;
        const { response, status } = yield call(apiCallHandler, networkConfig.getUserMiles, { queryProps: { uuid } }, {}, {});
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response.pickedData) {
            yield put({
                type: GET_USER_MILES_SUCCESS,
                payload: {
                    pickedData: response?.pickedData,
                },
            });
        }
        else {
            yield put({
                type: GET_USER_MILES_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_USER_MILES_ERROR,
        });
    }
}
export function* getUserMonthlyRankingCall(request) {
    try {
        const uuid = request?.payload?.userMiles?.MilesUUID;
        const params = {
            queryProps: {
                uuid,
            },
        };
        const { response, status } = yield call(apiCallHandler, networkConfig.getUserMonthlyRanking, params, {}, {});
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response.pickedData) {
            yield put({
                type: GET_MONTHLY_RANKING_SUCCESS,
                payload: {
                    monthlyRankingData: response?.pickedData,
                    uuid,
                },
            });
        }
        else {
            yield put({
                type: GET_MONTHLY_RANKING_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_MONTHLY_RANKING_ERROR,
        });
    }
}
export function* getUserPastMonthlyRankingCall(request) {
    try {
        const uuid = request?.payload?.userMiles?.MilesUUID;
        const currentDate = new Date();
        const lastYearDate = subYears(currentDate, 1);
        const params = {
            queryProps: {
                fromYM: format(lastYearDate, 'yyyyMM'),
                toYM: format(new Date(), 'yyyyMM'),
            },
        };
        if (!networkConfig.getUserMonthlyPastRanking.url?.includes(uuid)) {
            networkConfig.getUserMonthlyPastRanking.url = `${networkConfig.getUserMonthlyPastRanking.url}${uuid}?`;
        }
        const { response, status } = yield call(apiCallHandler, networkConfig.getUserMonthlyPastRanking, params, {}, {});
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response.pickedData) {
            yield put({
                type: GET_PAST_MONTHLY_RANKING_SUCCESS,
                payload: {
                    pastMonthlyRankingData: response?.pickedData,
                    uuid,
                },
            });
        }
        else {
            yield put({
                type: GET_PAST_MONTHLY_RANKING_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_PAST_MONTHLY_RANKING_ERROR,
        });
    }
}
export function* getRankingViewCall() {
    try {
        const currentDate = new Date();
        const lastMonthDate = subMonths(currentDate, 1);
        const ym = format(lastMonthDate, 'yyyyMM');
        const props = { queryProps: { ym, limit: 50 } };
        const { response, status } = yield call(apiCallHandler, networkConfig.getRankingView, props, {}, {});
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: GET_RANKING_View_SUCCESS,
                payload: {
                    rankingViewData: response?.pickedData,
                },
            });
        }
        else {
            yield put({
                type: GET_RANKING_View_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_RANKING_View_ERROR,
        });
    }
}
export function* getLastMonthRankingViewCall() {
    try {
        const ym = format(new Date(), 'yyyyMM');
        const props = { queryProps: { ym, limit: 50 } };
        const { response, status } = yield call(apiCallHandler, networkConfig.getRankingView, props, {}, {});
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response?.pickedData) {
            yield put({
                type: GET_LAST_MONTH_RANKING_View_SUCCESS,
                payload: {
                    lastMonthRankingViewData: response?.pickedData,
                },
            });
        }
        else {
            yield put({
                type: GET_LAST_MONTH_RANKING_View_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_LAST_MONTH_RANKING_View_ERROR,
        });
    }
}
export function* getOverallRankingCall(request) {
    try {
        const uuid = request?.payload?.userMiles?.MilesUUID;
        const props = { queryProps: { limit: 50 } };
        const { response, status } = yield call(apiCallHandler, networkConfig.getOverallRanking, props, {}, {});
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: GET_OVERALL_RANKING_SUCCESS,
                payload: {
                    overAllRankingData: response?.pickedData,
                    uuid,
                },
            });
        }
        else {
            yield put({
                type: GET_OVERALL_RANKING_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_OVERALL_RANKING_ERROR,
        });
    }
}
export function* getUserOverallRankingCall(request) {
    try {
        const uuid = request?.payload?.userMiles?.MilesUUID;
        const user_uuid = uuid;
        const props = { queryProps: { user_uuid, limit: 1 } };
        const { response, status } = yield call(apiCallHandler, networkConfig.getOverallRanking, props, {}, {});
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: GET_USER_OVERALL_RANKING_SUCCESS,
                payload: {
                    userOverAllRankingData: response?.pickedData[0] || {},
                    uuid,
                },
            });
        }
        else {
            yield put({
                type: GET_USER_OVERALL_RANKING_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_OVERALL_RANKING_ERROR,
        });
    }
}
export function* getUserMilesHistoryCurrentTabCall(request) {
    try {
        const uuid = request?.payload?.uuid;
        const params = {
            queryProps: {
                expired: false,
                show: 0,
            },
        };
        if (!networkConfig.getUserMilesHistory.url?.includes(uuid)) {
            networkConfig.getUserMilesHistory.url = `${networkConfig.getUserMilesHistory.url}${uuid}?`;
        }
        const { response, status } = yield call(apiCallHandler, networkConfig.getUserMilesHistory, params, {}, {});
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response?.pickedData) {
            yield put({
                type: GET_USER_MILES_CURRENT_HISTORY_SUCCESS,
                payload: { currentMilesHisory: response?.pickedData },
            });
        }
        else {
            yield put({
                type: GET_USER_MILES_CURRENT_HISTORY_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_USER_MILES_CURRENT_HISTORY_ERROR,
        });
    }
}
export function* getUserMilesHistoryPastTabCall(request) {
    try {
        const uuid = request?.payload?.uuid;
        const toIssueDate = request?.payload?.monthlyRankingData?.user?.starts_at;
        const parsedDate = new Date(toIssueDate);
        const lastYearFromIssueDate = subYears(parsedDate, 1);
        const dateParams = {
            toIssueDate: format(parsedDate, 'yyyyMMdd'),
            fromIssueDate: format(lastYearFromIssueDate, 'yyyyMMdd'),
        };
        const params = { queryProps: dateParams };
        if (!networkConfig.getUserMilesHistory.url?.includes(uuid)) {
            networkConfig.getUserMilesHistory.url = `${networkConfig.getUserMilesHistory.url}${uuid}?`;
        }
        const { response, status } = yield call(apiCallHandler, networkConfig.getUserMilesHistory, params, {}, {});
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response?.pickedData) {
            yield put({
                type: GET_USER_MILES_PAST_HISTORY_SUCCESS,
                payload: { pastMilesHisory: response?.pickedData },
            });
        }
        else {
            yield put({
                type: GET_USER_MILES_PAST_HISTORY_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_USER_MILES_PAST_HISTORY_ERROR,
        });
    }
}
export function* linkCardCall(request) {
    const cardNumber = request?.payload?.cardNumber;
    const pin = request?.payload?.pin;
    const pontaAccountID = request?.payload?.pontaAccountID;
    let cardToLink = '';
    let postBody = {};
    try {
        if (cardNumber && pin) {
            cardToLink = 'kfc';
            postBody = {
                card_number: cardNumber,
                card_pin: pin,
            };
        }
        else if (pontaAccountID) {
            cardToLink = 'ponta';
            postBody = {
                account_id: pontaAccountID,
            };
        }
        const params = { queryProps: { cardToLink } };
        if (cardToLink) {
            yield put(setIsLoading(true));
            const { response, status } = yield call(apiCallHandler, networkConfig.linkCard, params, {}, postBody);
            if (status >= 400) {
                yield put(setIsLoading(false));
                yield put(linkCardStatusMsg({ success: false, message: errorMessage }));
                yield put(setErrorCode(status));
                if (response && response.success === false && response.message) {
                    yield put(setErrorMsg(response.message));
                }
            }
            if (response) {
                yield put(setIsLoading(false));
                yield put(linkCardStatusMsg({ success: response?.success, message: response?.message }));
                yield put({
                    type: LINK_KFC_CARD_SUCCESS,
                    success: response.success,
                    message: response.message,
                });
            }
            else {
                yield put(setIsLoading(false));
                yield put(linkCardStatusMsg({ success: false, message: response?.message || errorMessage }));
                yield put({
                    type: LINK_KFC_CARD_ERROR,
                });
            }
        }
    }
    catch (error) {
        yield put(linkCardStatusMsg({ success: false, message: errorMessage }));
        yield put({
            type: LINK_KFC_CARD_ERROR,
        });
    }
}
export function* balanceInquiryAPICall(request) {
    try {
        yield put(setIsLoading(true));
        const { payload } = request;
        const { KFC_Card, KFC_PIN, linking } = payload || {};
        const postBody = {
            cardNo: KFC_Card,
            pin: KFC_PIN,
            category: 'Balance',
        };
        const { response, status } = yield call(apiCallHandler, networkConfig.balanceInquiryAPI, null, {}, postBody);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response.success) {
            yield put({
                type: BALANCE_INQUIRY_API_SUCCESS,
                payload: {
                    kfcLinkingData: response,
                },
            });
            if (response.BalanceAfter > 0) {
                yield put(setIsLoading(false));
                if (linking) {
                    yield put(linkCard({
                        cardNumber: KFC_Card,
                        pin: KFC_PIN,
                    }));
                }
            }
            else {
                yield put(setIsLoading(false));
            }
        }
        else {
            yield put(linkCardStatusMsg({ success: false, message: errorMessage }));
            yield put({
                type: BALANCE_INQUIRY_API_ERROR,
            });
            yield put(setIsLoading(false));
        }
    }
    catch (error) {
        yield put({
            type: BALANCE_INQUIRY_API_ERROR,
        });
    }
}
export function* unlinkCardCall(request) {
    try {
        const cardType = request?.payload;
        const params = { queryProps: { cardType } };
        if (cardType) {
            const { response, status } = yield call(apiCallHandler, networkConfig.unlinkCard, params, {}, {});
            if (status >= 400) {
                yield put(linkCardStatusMsg({ success: false, message: errorMessage }));
                yield put(setErrorCode(status));
            }
            if (response) {
                yield put(linkCardStatusMsg({ success: response?.success, message: response?.message }));
                yield put({
                    type: UNLINK_CARD_SUCCESS,
                });
            }
            else {
                yield put(linkCardStatusMsg({ success: false, message: errorMessage }));
                yield put({
                    type: UNLINK_CARD_ERROR,
                });
            }
        }
    }
    catch (error) {
        yield put(linkCardStatusMsg({ success: false, message: errorMessage }));
        yield put({
            type: UNLINK_CARD_ERROR,
        });
    }
}
export function* pontaMemberIDCall(request) {
    try {
        const pontaAccountID = request?.pontaAccountID;
        const postBody = {
            webAuthCertificate: pontaAccountID,
            siteIdentifier: '7f9c5d96e1593c77bd8cacfc2b1d8e19',
        };
        const { response, status } = yield call(apiCallHandler, networkConfig.pontaMemberID, null, {}, postBody);
        if (status >= 400) {
            yield put(linkCardStatusMsg({ success: false, message: errorMessage }));
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put(setIsLoading(false));
            yield put({
                type: PONTA_MEMBER_ID_SUCCESS,
                payload: {
                    pontaAccountID: response.MemberId,
                },
            });
        }
        else {
            yield put(linkCardStatusMsg({ success: false, message: errorMessage }));
            yield put({
                type: PONTA_MEMBER_ID_ERROR,
            });
        }
    }
    catch (error) {
        yield put(linkCardStatusMsg({ success: false, message: errorMessage }));
        yield put({
            type: PONTA_MEMBER_ID_ERROR,
        });
    }
}
export function* navigateToExternalWebsiteCall(request) {
    const externalURL = request.payload.externalURL;
    yield new Promise((resolve) => {
        window.location.href = externalURL;
        resolve();
    });
}
export function* getUserInfoFromMilesSaga() {
    yield takeLatest(GET_USER_INFO_FROM_MILES, getUserInfoFromMilesCall);
}
export function* createUserMilesSaga() {
    yield takeLatest(GET_USER_INFO_FROM_MILES_ERROR, createUserMilesCall);
}
export function* getupdatedUserInfoFromMilesSaga() {
    yield takeLatest(UNLINK_CARD_SUCCESS, getUserInfoFromMilesCall);
}
export function* getupdatedUserKFCLinkageSaga() {
    yield takeLatest(LINK_KFC_CARD_SUCCESS, getUserInfoFromMilesCall);
}
export function* getUserMilesSaga() {
    yield takeLatest(GET_USER_INFO_FROM_MILES_SUCCESS, getUserMilesCall);
}
export function* getUserMonthlyRankingSaga() {
    yield takeLatest(GET_USER_INFO_FROM_MILES_SUCCESS, getUserMonthlyRankingCall);
}
export function* getUserPastMonthlyRankingSaga() {
    yield takeLatest(GET_USER_INFO_FROM_MILES_SUCCESS, getUserPastMonthlyRankingCall);
}
export function* getRankingViewSaga() {
    yield takeLatest(GET_USER_INFO_FROM_MILES_SUCCESS, getRankingViewCall);
}
export function* getLastMonthRankingViewSaga() {
    yield takeLatest(GET_USER_INFO_FROM_MILES_SUCCESS, getLastMonthRankingViewCall);
}
export function* getOverallRankingSaga() {
    yield takeLatest(GET_USER_INFO_FROM_MILES_SUCCESS, getOverallRankingCall);
}
export function* getUserOverallRankingSaga() {
    yield takeLatest(GET_USER_INFO_FROM_MILES_SUCCESS, getUserOverallRankingCall);
}
export function* getUserMilesHistoryPastTabSaga() {
    yield takeLatest(GET_MONTHLY_RANKING_SUCCESS, getUserMilesHistoryPastTabCall);
}
export function* getUserMilesHistoryCurrentTabSaga() {
    yield takeLatest(GET_MONTHLY_RANKING_SUCCESS, getUserMilesHistoryCurrentTabCall);
}
export function* balanceInquiryAPISaga() {
    yield takeLatest(BALANCE_INQUIRY_API, balanceInquiryAPICall);
}
export function* unlinkCardSaga() {
    yield takeLatest(UNLINK_CARD, unlinkCardCall);
}
export function* linkCardSaga() {
    yield takeLatest(LINK_KFC_CARD, linkCardCall);
}
export function* linkPontaPointSaga() {
    yield takeLatest(PONTA_MEMBER_ID_SUCCESS, linkCardCall);
}
export function* navigateToExternalWebsiteSaga() {
    yield takeLatest(NAVIGATE_TO_EXTERNAL_WEBSITE, navigateToExternalWebsiteCall);
}
export function* pontaMemberIDSaga() {
    yield takeLatest(STORE_RETURNED_ACCOUNT_ID, pontaMemberIDCall);
}
